import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'clsx';

import style from './style.module.css';

/**
 * This component displays as much text as possible on one line.
 * It does not prevent the parent component from growing. Be sure to set a 'max-width' on parent component to enable expected behavior.
 * @param {{ value: node, className: string|void }} props
 * @returns {JSX.Element}
 */
export const TruncatedText = ({ value, className }) => (
  <div className={classNames(style.truncated, className)} title={value}>
    {value}
  </div>
);

TruncatedText.propTypes = {
  value: PropTypes.node.isRequired,
  className: PropTypes.string,
};
